<style scoped lang="scss">
.carmine-content-div {
    margin-bottom: 5rem !important;
    background-color: rgb(242 242 242) !important;
    font-size: 1rem;
}

.carmine-table-div {
    background-color: white;
    padding: 1rem;
}

.show-carmine-div {
    background-color: black;
    color: white;
    overflow: auto;
    padding: 1rem;
    border-radius: 0.2rem;
}

.carmine-table {
    margin-top: 0.5rem;
    width: 100%;
}

// pc端
@media screen and (min-width: 768px) {


    .carmine-table-div {
        margin-top: 3rem;
        margin-left: 3rem;

    }

    .show-carmine-div {
        max-width: 50vw;
        max-height: 70vh;
    }
}

//移动端
@media screen and (max-width: 769px) {
    .carmine-table-div {
        width: fit-content;
        min-width: 50rem;
        margin-top: 1rem;
        margin-left: 1rem;
    }

    .carmine-content-div {
        min-width: fit-content;
        padding-right: 1rem;
        padding-bottom: 3rem;
    }

    .show-carmine-div {
        max-width: 80vw;
        max-height: 70vh;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;padding-left: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;height:100vh;">
                    <div class="carmine-content-div">
                        <div class="carmine-table-div  rounded shadow">
                            <div>
                                <el-button type="primary" @click="toAddCarmineDialog">生成卡密</el-button>
                                <el-button type="success" @click="toUseCarmine">使用卡密</el-button>
                                <el-button type="danger" @click="toUseCarmine">验证卡密</el-button>
                            </div>
                            <el-table :data="carmineList" class="carmine-table" size="small">
                                <el-table-column prop="id" label="ID" width="100" />
                                <el-table-column prop="carmine" label="卡密" width="200" />
                                <el-table-column prop="state" label="状态" width="180">
                                    <template #default="scope">
                                        <div v-if="scope.row.state == 1" class="text-success">
                                            未使用 </div>
                                        <div v-else-if="scope.row.state == 0" class="text-danger">已使用</div>
                                        <div v-else-if="scope.row.state == -1" class="text-danger">已禁用</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="usedUid" label="使用者UID" />
                                <el-table-column prop="usedTime" label="使用时间" width="180" />
                                <el-table-column prop="timeUnit" label="类型">
                                    <template #default="scope">
                                        {{ getTimeUnit(scope.row.timeUnit) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pluginName" label="插件" />
                                <el-table-column prop="versionName" label="插件版本" />
                            </el-table>
                            <el-pagination class="mt-3" style="    margin: 0 auto;width: fit-content;"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="total" />
                        </div>
                        <!-- 生成卡密 -->
                        <el-dialog v-model="addCarmineDialog.isShow" title="生成卡密" width="500" align-center>
                            <div class="ml-4">
                                <div class="mt-3">
                                    <span>选择插件</span>
                                    <el-select v-model="addCarmineDialog.plugin"
                                        @change="getTimeMealAndVersions(addCarmineDialog.plugin)" placeholder="请选择插件">
                                        <el-option v-for="(item) in addCarmineDialog.includes_list"
                                            :key="item.includes_id" :label="item.includes_id + '---' + item.includes_name +
                                                '---' + item.grade_name" :value="item.includes_id" />
                                        <el-option v-if="addCarmineDialog.includes_list.length == 0"
                                            disabled>--暂无插件/您不是任何插件的代理--</el-option>
                                    </el-select>
                                </div>

                                <!-- Version Selection (similar to IncludesList.vue) -->
                                <div class="mt-3" v-if="addCarmineDialog.version_list.length > 1">
                                    <span>选择版本</span>
                                    <el-select v-model="addCarmineDialog.version"
                                        @change="getTimeMeal(addCarmineDialog.plugin)" placeholder="请选择版本">
                                        <el-option v-for="item in addCarmineDialog.version_list"
                                            :key="'version_select_' + item.version" :label="item.name"
                                            :value="item.version" />
                                    </el-select>
                                </div>

                                <div class="mt-3">
                                    <span>选择时长类型</span>
                                    <el-select v-model="addCarmineDialog.time"
                                        @change="setTimeMeal(addCarmineDialog.time)" placeholder="请选择时长单位">
                                        <el-option v-for="(item) in addCarmineDialog.time_meal_list" :key="item.meal_id"
                                            :label="item.time_unit + '---' + item.price + '元'" :value="item.meal_id" />
                                    </el-select>
                                </div>
                                <div class="mt-3">
                                    <span>卡密数量</span>
                                    <br>
                                    <el-input-number v-model="addCarmineDialog.num" placeholder="请输入卡密数量" />
                                </div>
                                <div class="mt-3">
                                    <span>共计</span>
                                    <div class="money_total_num">{{ (addCarmineDialog.price *
                                        addCarmineDialog.num).toFixed(2) }}元
                                    </div>
                                </div>
                            </div>
                            <template #footer>
                                <div class="dialog-footer">
                                    <el-button @click="addCarmineDialog.isShow = false">取消</el-button>
                                    <el-button type="primary" @click="addCarmineConfirm()">
                                        生成
                                    </el-button>
                                </div>
                            </template>
                        </el-dialog>
                        <el-dialog v-model="showCarmineDialog.isShow" title="卡密详情" width="500" align-center>
                            <div class="show-carmine-div">
                                <div>以下是您的卡密信息：</div>
                                <div v-for="(item, i) in showCarmineDialog.list" :key="i">
                                    {{ item }}</div>
                            </div>
                            <template #footer>
                                <div class="dialog-footer">
                                    <el-button @click="showCarmineDialog.isShow = false">确定</el-button>
                                </div>
                            </template>
                        </el-dialog>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox } from "@/utils/publicMethods"
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import router from '@/router';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            carmineList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            addCarmineDialog: {
                isShow: false,
                plugin: '',
                time: '',
                num: 1,
                price: 0.0,
                version: 1, // Add version field
                includes_list: [],
                time_meal_list: [],
                version_list: [] // Add version list
            },
            showCarmineDialog: {
                isShow: false,
                list: []
            }
        };
    },
    methods: {
        fetchCarmineList() {
            // 模拟从后端获取数据
            axios.post(baseURL + '/carmine/list',
                {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize

                }, {
                timeout: 10000,
                headers: {
                    'token': localStorage.getItem("token")
                }
            }).then(response => {
                if (response.data.code == 200) {
                    this.carmineList = response.data.data.list;
                    this.total = response.data.data.total;
                } else if (response.data.code == 401) {
                    ElMessage.error(response.data.msg)
                    setTimeout(() => {
                        location.href = "/Login"
                    }, 1000);

                } else {
                    ElMessage.error(response.data.msg)
                }

            }).catch(error => {
                console.error('获取卡密列表失败:', error);
            });
        },
        getTimeMealAndVersions(includes_id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("includes_id", includes_id)
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        ElMessage.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    else if (res.data.code == 200) {
                        // Handle version data like in IncludesList.vue
                        const versions_data = res.data.data.data;

                        // Reset version list
                        this.addCarmineDialog.version_list = []
                        this.addCarmineDialog.version = 1

                        // Process each version
                        versions_data.forEach((version_item, index) => {
                            const version_name = version_item.version_name || `版本 ${version_item.version}`;

                            // Store version data
                            this.addCarmineDialog.version_list.push({
                                name: version_name,
                                version: version_item.version,
                                desc: version_item.version_desc || '',
                                meals: version_item.grade_arr
                            });
                        });
                        this.getTimeMeal(includes_id)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('获取版本和价格信息失败：' + err.message)
                })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.fetchCarmineList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchCarmineList();
        }, toUseCarmine() {
            router.push('/CarmineUse');
        },
        getTimeUnit(type) {
            if (type == 'day') {
                return '天'
            } else if (type == 'month') {
                return '月'
            } else if (type == 'year') {
                return '年'

            } else if (type == 'forever') {
                return '永久'
            }
            else {
                return '未知'
            }
        },
        toAddCarmineDialog() {
            this.addCarmineDialog.isShow = true;
            this.getIncludesList()

        },
        getIncludesList() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("act", 'getEmpowerIncludesList')
            axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    else if (res.data.code == 200) {
                        this.addCarmineDialog.includes_list = res.data.data;
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('获取代理插件列表失败：' + err.message)
                })
        }, getTimeMeal(includes_id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("includes_id", includes_id)
            data.append("version", this.addCarmineDialog.version)
            data.append("act", "getTimeMeal")
            axios.post(baseURL + "/userApi/getInfo", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        ElMessage.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        this.addCarmineDialog.time_meal_list = res.data.data
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('请求失败：' + err.message)
                })
        },
        setTimeMeal(time) {
            var element = this.addCarmineDialog.time_meal_list.filter(item => item.meal_id == time);
            this.addCarmineDialog.num = 1
            this.addCarmineDialog.price = element[0].price
        }, addCarmine() {
            openLoading();
            const headers = {
                'token': localStorage.getItem("token")
            };
            axios.post(baseURL + "/carmine/add", {
                pluginId: this.addCarmineDialog.plugin,
                mealId: this.addCarmineDialog.time,
                num: this.addCarmineDialog.num,
                version: this.addCarmineDialog.version
            }, { timeout: 10000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        ElMessage.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        this.showCarmineDialog.isShow = true;
                        this.addCarmineDialog.isShow = false;
                        this.showCarmineDialog.list = res.data.data.list
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('请求失败：' + err.message)
                })
        },
        addCarmineConfirm() {
            ElMessageBox.confirm(
                '确定生成卡密？',
                'warn',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '关闭',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.addCarmine();
                }).catch(() => {
                    console.log("");
                })
        }
    },
    created() {
        this.fetchCarmineList();
    }
})
</script>
